var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconBack = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 10",
    width: 12,
    height: 10,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 4.749a.748.748 0 0 1 .218-.529l.002-.002.001-.001a.757.757 0 0 1 .046-.042L4.222.22a.75.75 0 0 1 1.06 1.06L2.566 4h8.185a.75.75 0 0 1 0 1.5H2.56L5.284 8.22a.75.75 0 1 1-1.061 1.06L.267 5.327A.748.748 0 0 1 0 4.749Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconBack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-back.4f2f165204922b7479c7b22a0fb3306f.svg";